export const categories = [
  "Cheese",
  "Charcuterie",
  "Seafood",
  "Pantry",
  "Bakery",
  "Gifts",
];

const productData = [
  {
    id: 1,
    slug: "reserve-clothbound-cheddar",
    name: "Reserve Clothbound Cheddar",
    category: "Cheese",
    subcategory: "Aged Cheese",
    price: 52,
    originalPrice: null,
    image: "/img/products/product-01.png",
    images: ["/img/products/product-01.png"],
    description:
      "A cave-aged farmhouse cheddar with a crumbly texture and savory notes of toasted hazelnut, brown butter, and warm hay.",
    attributes: {
      origin: "Singapore",
      weight: "225 g",
      milk: "Pasteurized cow's milk",
      age: "14 months",
      storage: "Keep refrigerated",
    },
    tags: ["clothbound", "sharp", "cheese board"],
    rating: 4.9,
    reviews: 128,
    stock: 34,
    featured: true,
    newArrival: false,
  },
  {
    id: 2,
    slug: "triple-cream-bloom-brie",
    name: "Triple Cream Bloom Brie",
    category: "Cheese",
    subcategory: "Soft-Ripened Cheese",
    price: 58,
    originalPrice: 65,
    image: "/img/products/product-02.png",
    images: ["/img/products/product-02.png"],
    description:
      "A lush bloomy-rind cheese with a cloud-soft center, delicate mushroom aroma, and a clean cultured-cream finish.",
    attributes: {
      origin: "Singapore",
      weight: "200 g",
      milk: "Pasteurized cow's milk",
      texture: "Soft and creamy",
      storage: "Keep refrigerated",
    },
    tags: ["triple cream", "bloomy rind", "celebration"],
    rating: 4.8,
    reviews: 94,
    stock: 18,
    featured: true,
    newArrival: true,
  },
  {
    id: 3,
    slug: "cellar-veined-blue-cheese",
    name: "Cellar-Veined Blue Cheese",
    category: "Cheese",
    subcategory: "Blue Cheese",
    price: 49,
    originalPrice: null,
    image: "/img/products/product-03.png",
    images: ["/img/products/product-03.png"],
    description:
      "A buttery blue with striking mineral veins, balanced salinity, and a lingering cocoa-and-walnut character.",
    attributes: {
      origin: "Singapore",
      weight: "170 g",
      milk: "Pasteurized cow's milk",
      age: "Five months",
      storage: "Keep refrigerated",
    },
    tags: ["blue cheese", "bold", "artisan"],
    rating: 4.7,
    reviews: 76,
    stock: 27,
    featured: false,
    newArrival: true,
  },
  {
    id: 4,
    slug: "applewood-smoked-gouda",
    name: "Applewood Smoked Gouda",
    category: "Cheese",
    subcategory: "Smoked Cheese",
    price: 47,
    originalPrice: null,
    image: "/img/products/product-04.png",
    images: ["/img/products/product-04.png"],
    description:
      "Supple young gouda gently cold-smoked over applewood for mellow caramel sweetness and a refined campfire finish.",
    attributes: {
      origin: "Singapore",
      weight: "225 g",
      milk: "Pasteurized cow's milk",
      texture: "Smooth and semi-firm",
      storage: "Keep refrigerated",
    },
    tags: ["smoked", "gouda", "mellow"],
    rating: 4.6,
    reviews: 61,
    stock: 42,
    featured: false,
    newArrival: false,
  },
  {
    id: 5,
    slug: "juniper-cured-prosciutto",
    name: "Juniper-Cured Prosciutto",
    category: "Charcuterie",
    subcategory: "Dry-Cured Ham",
    price: 55,
    originalPrice: null,
    image: "/img/products/product-05.png",
    images: ["/img/products/product-05.png"],
    description:
      "Paper-thin heritage pork ham cured with juniper and sea salt, offering a silky texture and gentle forest aroma.",
    attributes: {
      origin: "Singapore",
      weight: "115 g",
      protein: "Pork",
      cureTime: "Fourteen months",
      storage: "Keep refrigerated",
    },
    tags: ["prosciutto", "heritage pork", "thin sliced"],
    rating: 4.8,
    reviews: 112,
    stock: 48,
    featured: true,
    newArrival: false,
  },
  {
    id: 6,
    slug: "wild-fennel-salami",
    name: "Wild Fennel Salami",
    category: "Charcuterie",
    subcategory: "Dry-Cured Salami",
    price: 46,
    originalPrice: 52,
    image: "/img/products/product-06.png",
    images: ["/img/products/product-06.png"],
    description:
      "Small-batch pork salami cured with toasted fennel seed, cracked pepper, and garlic for a fragrant savory bite.",
    attributes: {
      origin: "Singapore",
      weight: "170 g",
      protein: "Pork",
      cureTime: "Eight weeks",
      storage: "Refrigerate after opening",
    },
    tags: ["dry cured", "fennel", "ready to slice"],
    rating: 4.7,
    reviews: 83,
    stock: 21,
    featured: false,
    newArrival: true,
  },
  {
    id: 7,
    slug: "country-herb-pate-terrine",
    name: "Country Herb Pâté Terrine",
    category: "Charcuterie",
    subcategory: "Pâté & Terrine",
    price: 62,
    originalPrice: null,
    image: "/img/products/product-07.png",
    images: ["/img/products/product-07.png"],
    description:
      "A rustic hand-packed terrine folded with pistachio, thyme, and orange zest, ready for crusty bread and cornichons.",
    attributes: {
      origin: "Singapore",
      weight: "200 g",
      protein: "Duck and pork",
      allergens: "Contains pistachio",
      storage: "Keep refrigerated",
    },
    tags: ["terrine", "country pâté", "entertaining"],
    rating: 4.6,
    reviews: 52,
    stock: 14,
    featured: false,
    newArrival: false,
  },
  {
    id: 8,
    slug: "cracked-pepper-bresaola",
    name: "Cracked Pepper Bresaola",
    category: "Charcuterie",
    subcategory: "Air-Dried Beef",
    price: 57,
    originalPrice: null,
    image: "/img/products/product-08.png",
    images: ["/img/products/product-08.png"],
    description:
      "Lean beef eye round air-dried with black pepper and coriander for a tender texture and concentrated flavor.",
    attributes: {
      origin: "Singapore",
      weight: "115 g",
      protein: "Beef",
      cureTime: "Ten weeks",
      storage: "Keep refrigerated",
    },
    tags: ["air dried", "peppercorn", "lean"],
    rating: 4.9,
    reviews: 69,
    stock: 16,
    featured: true,
    newArrival: true,
  },
  {
    id: 9,
    slug: "midnight-pearl-caviar",
    name: "Midnight Pearl Caviar",
    category: "Seafood",
    subcategory: "Caviar & Roe",
    price: 138,
    originalPrice: 158,
    image: "/img/products/product-09.png",
    images: ["/img/products/product-09.png"],
    description:
      "Glossy dark pearls with a delicate pop, clean marine salinity, and a lingering buttery finish for special occasions.",
    attributes: {
      origin: "Singapore",
      weight: "30 g",
      species: "White sturgeon",
      serving: "Serves 2 to 4",
      storage: "Keep refrigerated at -2–0°C",
    },
    tags: ["caviar", "celebration", "sturgeon roe"],
    rating: 4.9,
    reviews: 147,
    stock: 25,
    featured: true,
    newArrival: false,
  },
  {
    id: 10,
    slug: "beechwood-smoked-salmon",
    name: "Beechwood Smoked Salmon",
    category: "Seafood",
    subcategory: "Smoked Fish",
    price: 72,
    originalPrice: null,
    image: "/img/products/product-10.png",
    images: ["/img/products/product-10.png"],
    description:
      "Hand-sliced salmon cold-smoked over beechwood for a satin texture, gentle salinity, and clean ocean finish.",
    attributes: {
      origin: "Singapore",
      weight: "225 g",
      preparation: "Cold-smoked and hand-sliced",
      serving: "Serves 4 to 6",
      storage: "Keep refrigerated",
    },
    tags: ["smoked salmon", "brunch", "hand sliced"],
    rating: 4.8,
    reviews: 108,
    stock: 20,
    featured: true,
    newArrival: true,
  },
  {
    id: 11,
    slug: "citrus-herb-green-olives",
    name: "Citrus-Herb Green Olives",
    category: "Pantry",
    subcategory: "Olives & Antipasti",
    price: 45,
    originalPrice: null,
    image: "/img/products/product-11.png",
    images: ["/img/products/product-11.png"],
    description:
      "Plump green olives marinated with lemon peel, thyme, and coriander for a bright, gently briny aperitivo staple.",
    attributes: {
      origin: "Singapore",
      weight: "280 g",
      ingredients: "Green olives, lemon, thyme, coriander, sea salt",
      dietary: "Vegan and gluten-free",
      storage: "Refrigerate after opening",
    },
    tags: ["olives", "aperitivo", "vegan"],
    rating: 4.6,
    reviews: 73,
    stock: 63,
    featured: false,
    newArrival: false,
  },
  {
    id: 12,
    slug: "charred-herb-octopus",
    name: "Charred Herb Octopus",
    category: "Seafood",
    subcategory: "Prepared Seafood",
    price: 86,
    originalPrice: 98,
    image: "/img/products/product-12.png",
    images: ["/img/products/product-12.png"],
    description:
      "Tender octopus tentacles gently cooked, flame-charred, and dressed with lemon and oregano for effortless serving.",
    attributes: {
      origin: "Singapore",
      weight: "280 g",
      preparation: "Fully cooked; serve chilled or gently warm",
      allergens: "Contains molluscan shellfish",
      storage: "Keep refrigerated",
    },
    tags: ["octopus", "charred", "ready to serve"],
    rating: 4.8,
    reviews: 86,
    stock: 12,
    featured: true,
    newArrival: true,
  },
  {
    id: 13,
    slug: "garden-tomato-basil-sauce",
    name: "Garden Tomato Basil Sauce",
    category: "Pantry",
    subcategory: "Sauces & Preserves",
    price: 45,
    originalPrice: null,
    image: "/img/products/product-13.png",
    images: ["/img/products/product-13.png"],
    description:
      "Slow-simmered summer tomatoes with sweet basil, roasted garlic, and olive oil for a vibrant weeknight sauce.",
    attributes: {
      origin: "Singapore",
      weight: "680 g",
      ingredients: "Tomatoes, basil, olive oil, garlic, sea salt",
      dietary: "Vegan and gluten-free",
      storage: "Refrigerate after opening",
    },
    tags: ["tomato", "basil", "small batch"],
    rating: 4.7,
    reviews: 131,
    stock: 57,
    featured: true,
    newArrival: false,
  },
  {
    id: 14,
    slug: "early-harvest-olive-oil",
    name: "Early Harvest Olive Oil",
    category: "Pantry",
    subcategory: "Oils & Vinegars",
    price: 64,
    originalPrice: null,
    image: "/img/products/product-14.png",
    images: ["/img/products/product-14.png"],
    description:
      "Vibrant extra-virgin olive oil pressed from early fruit, with aromas of cut grass and a peppery green-almond finish.",
    attributes: {
      origin: "Singapore",
      volume: "500 ml",
      harvest: "Early season",
      ingredients: "100% extra-virgin olive oil",
      storage: "Store in a cool, dark place",
    },
    tags: ["extra virgin", "cold pressed", "finishing oil"],
    rating: 4.9,
    reviews: 88,
    stock: 44,
    featured: true,
    newArrival: true,
  },
  {
    id: 15,
    slug: "sea-seed-savory-crackers",
    name: "Sea-Seed Savory Crackers",
    category: "Bakery",
    subcategory: "Crackers & Flatbreads",
    price: 45,
    originalPrice: 50,
    image: "/img/products/product-15.png",
    images: ["/img/products/product-15.png"],
    description:
      "Extra-crisp olive oil crackers scattered with sesame, flax, sunflower seed, and flaky salt for cheese-board crunch.",
    attributes: {
      origin: "Singapore",
      weight: "170 g",
      ingredients: "Wheat flour, olive oil, mixed seeds, sea salt",
      allergens: "Contains wheat and sesame",
      storage: "Store sealed in a cool, dry place",
    },
    tags: ["seeded", "crackers", "cheese board"],
    rating: 4.6,
    reviews: 64,
    stock: 38,
    featured: false,
    newArrival: false,
  },
  {
    id: 16,
    slug: "bronze-cut-pasta-nests",
    name: "Bronze-Cut Pasta Nests",
    category: "Pantry",
    subcategory: "Pasta & Grains",
    price: 48,
    originalPrice: null,
    image: "/img/products/product-16.png",
    images: ["/img/products/product-16.png"],
    description:
      "Silky egg pasta shaped through bronze dies and arranged by hand into nests that hold rich sauces beautifully.",
    attributes: {
      origin: "Singapore",
      weight: "340 g",
      cookTime: "Six to eight minutes",
      allergens: "Contains wheat and egg",
      storage: "Store in a cool, dry place",
    },
    tags: ["egg pasta", "bronze cut", "hand nested"],
    rating: 4.5,
    reviews: 47,
    stock: 51,
    featured: false,
    newArrival: true,
  },
  {
    id: 17,
    slug: "black-truffle-blossom-honey",
    name: "Black Truffle Blossom Honey",
    category: "Pantry",
    subcategory: "Honey & Sweeteners",
    price: 59,
    originalPrice: null,
    image: "/img/products/product-17.png",
    images: ["/img/products/product-17.png"],
    description:
      "Floral wildflower honey infused with aromatic black truffle, made for blue cheese, roasted vegetables, or warm bread.",
    attributes: {
      origin: "Singapore",
      weight: "225 g",
      ingredients: "Wildflower honey, black truffle",
      dietary: "Gluten-free",
      storage: "Store at room temperature",
    },
    tags: ["truffle", "honey", "cheese pairing"],
    rating: 4.9,
    reviews: 154,
    stock: 22,
    featured: true,
    newArrival: false,
  },
  {
    id: 18,
    slug: "orchard-apricot-preserve",
    name: "Orchard Apricot Preserve",
    category: "Pantry",
    subcategory: "Sauces & Preserves",
    price: 45,
    originalPrice: null,
    image: "/img/products/product-18.png",
    images: ["/img/products/product-18.png"],
    description:
      "Sun-ripe apricots cooked in small copper kettles with cane sugar and lemon for a bright, fruit-forward preserve.",
    attributes: {
      origin: "Singapore",
      weight: "255 g",
      ingredients: "Apricots, cane sugar, lemon juice",
      dietary: "Vegan and gluten-free",
      storage: "Refrigerate after opening",
    },
    tags: ["apricot", "preserve", "small batch"],
    rating: 4.8,
    reviews: 119,
    stock: 17,
    featured: false,
    newArrival: true,
  },
  {
    id: 19,
    slug: "barrel-aged-balsamic-vinegar",
    name: "Barrel-Aged Balsamic Vinegar",
    category: "Pantry",
    subcategory: "Oils & Vinegars",
    price: 68,
    originalPrice: 76,
    image: "/img/products/product-19.png",
    images: ["/img/products/product-19.png"],
    description:
      "A dense, aromatic balsamic matured in a progression of wood barrels for notes of fig, cocoa, and sweet spice.",
    attributes: {
      origin: "Singapore",
      volume: "250 ml",
      age: "Five years",
      ingredients: "Cooked grape must, wine vinegar",
      storage: "Store in a cool, dark place",
    },
    tags: ["balsamic", "barrel aged", "finishing vinegar"],
    rating: 4.7,
    reviews: 72,
    stock: 19,
    featured: false,
    newArrival: false,
  },
  {
    id: 20,
    slug: "hand-harvested-sea-salt-flakes",
    name: "Hand-Harvested Sea Salt Flakes",
    category: "Pantry",
    subcategory: "Salt & Spices",
    price: 45,
    originalPrice: null,
    image: "/img/products/product-20.png",
    images: ["/img/products/product-20.png"],
    description:
      "Delicate pyramid-shaped sea salt crystals with a clean mineral flavor and crisp finish for tableside seasoning.",
    attributes: {
      origin: "Singapore",
      weight: "115 g",
      harvest: "Hand skimmed",
      ingredients: "Sea salt",
      storage: "Store in a cool, dry place",
    },
    tags: ["sea salt", "finishing salt", "hand harvested"],
    rating: 4.6,
    reviews: 55,
    stock: 74,
    featured: false,
    newArrival: true,
  },
  {
    id: 21,
    slug: "cultured-sea-salt-butter-curls",
    name: "Cultured Sea Salt Butter Curls",
    category: "Cheese",
    subcategory: "Cultured Butter",
    price: 51,
    originalPrice: null,
    image: "/img/products/product-21.png",
    images: ["/img/products/product-21.png"],
    description:
      "Silky cultured butter formed into elegant curls and finished with sea salt, ready to serve at brunch or dinner.",
    attributes: {
      origin: "Singapore",
      weight: "225 g",
      milk: "Pasteurized cow's cream",
      butterfat: "86%",
      storage: "Keep refrigerated",
    },
    tags: ["cultured butter", "sea salt", "table ready"],
    rating: 4.9,
    reviews: 138,
    stock: 15,
    featured: true,
    newArrival: false,
  },
  {
    id: 22,
    slug: "toasted-almond-biscotti",
    name: "Toasted Almond Biscotti",
    category: "Bakery",
    subcategory: "Cookies & Biscuits",
    price: 49,
    originalPrice: null,
    image: "/img/products/product-22.png",
    images: ["/img/products/product-22.png"],
    description:
      "Twice-baked almond biscuits with crisp edges, a tender center, and fragrant orange zest for coffee-side dipping.",
    attributes: {
      origin: "Singapore",
      weight: "280 g",
      quantity: "12 biscotti",
      allergens: "Contains almonds, wheat, milk, and egg",
      storage: "Store sealed at room temperature",
    },
    tags: ["biscotti", "almond", "coffee pairing"],
    rating: 4.8,
    reviews: 103,
    stock: 20,
    featured: true,
    newArrival: true,
  },
  {
    id: 23,
    slug: "midnight-sea-salt-chocolate",
    name: "Midnight Sea Salt Chocolate",
    category: "Gifts",
    subcategory: "Chocolate Gifts",
    price: 54,
    originalPrice: 62,
    image: "/img/products/product-23.png",
    images: ["/img/products/product-23.png"],
    description:
      "Deep 72% dark chocolate finished with delicate sea salt flakes and wrapped in an elegant gift-ready sleeve.",
    attributes: {
      origin: "Singapore",
      weight: "140 g",
      cacao: "72% dark cacao",
      allergens: "Made in a facility that handles milk and nuts",
      packaging: "Recyclable gift sleeve",
    },
    tags: ["dark chocolate", "sea salt", "gift ready"],
    rating: 4.7,
    reviews: 67,
    stock: 43,
    featured: false,
    newArrival: true,
  },
  {
    id: 24,
    slug: "rosemary-roasted-almonds",
    name: "Rosemary-Roasted Almonds",
    category: "Gifts",
    subcategory: "Savory Gifts",
    price: 48,
    originalPrice: null,
    image: "/img/products/product-24.png",
    images: ["/img/products/product-24.png"],
    description:
      "Whole almonds slow-roasted with fresh rosemary, olive oil, and sea salt, presented in a reusable gifting tin.",
    attributes: {
      origin: "Singapore",
      weight: "255 g",
      ingredients: "Almonds, olive oil, rosemary, sea salt",
      allergens: "Contains almonds",
      packaging: "Reusable metal gift tin",
    },
    tags: ["almonds", "rosemary", "host gift"],
    rating: 4.8,
    reviews: 91,
    stock: 31,
    featured: false,
    newArrival: false,
  },
  {
    id: 25,
    slug: "ceremonial-matcha-truffle-box",
    name: "Ceremonial Matcha Truffle Box",
    category: "Gifts",
    subcategory: "Chocolate Gifts",
    price: 66,
    originalPrice: null,
    image: "/img/products/product-25.png",
    images: ["/img/products/product-25.png"],
    description: "Twelve smooth white-chocolate truffles balanced with fragrant matcha, arranged in a gift-ready presentation box.",
    attributes: {
      origin: "Singapore",
      weight: "200 g",
      quantity: "12 truffles",
      allergens: "Contains milk and soy; made in a facility that handles nuts",
      packaging: "Recyclable gift box",
    },
    tags: ["matcha", "truffles", "gift ready"],
    rating: 4.8,
    reviews: 46,
    stock: 29,
    featured: true,
    newArrival: true,
  },
];

export { productData };
export default productData;
